import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

export default function TrackOrder(){
  const { oid } = useParams()
  const [sp] = useSearchParams()
  const [data, setData] = useState(null)
  const [err, setErr] = useState(null)

  useEffect(()=>{
    const code = sp.get('code'); const token = sp.get('token')
    fetch(process.env.REACT_APP_FUNCTIONS_URL + '/getGuestOrderForTracking', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ orderId: oid, code, token })
    }).then(r=>r.json()).then(setData).catch(e=>setErr(e.message))
  }, [oid])

  if (err) return <div className="alert alert-danger">{String(err)}</div>
  if (!data) return <div className="alert alert-info">Chargement...</div>

  return (
    <div className="card-modern p-4">
      <h3 className="mb-3">Suivi commande</h3>
      <div><strong>Statut:</strong> {data.status}</div>
      <div><strong>Total:</strong> {data.totals?.grandTotal?.toLocaleString()} XOF</div>
      <div className="mt-3"><strong>Articles:</strong></div>
      <ul className="mb-0">
        {data.items?.map((it, idx)=>(<li key={idx}>{it.title} × {it.qty}</li>))}
      </ul>
    </div>
  )
}
